import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography,
} from '@mui/material';
import useSiteFooterStyle from '../styles/SiteFooterStyles.jsx';

const SiteFooter = ({ isMobile }) => {
  const classes = useSiteFooterStyle();

  return (
    <Box className={isMobile ? `${classes.root} ${classes.rootMobile}` : classes.root}>
      <Typography className={classes.footer}> &copy; 2022 - Tingjun Man</Typography>
    </Box>
  );
};

SiteFooter.propTypes = {
  isMobile: PropTypes.bool,
};

export default SiteFooter;
